/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_PURCHASE_ORDERS_PRODUCTS, GET_PURCHASE_ORDERS_PRODUCTS } from 'src/actions/purchaseOrderProductAction';

const initialState = {
  items: [],
  total: 0,
  message: ''
};

const purchaseOrdersProductsReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_PURCHASE_ORDERS_PRODUCTS: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_PURCHASE_ORDERS_PRODUCTS: {
      const { purchaseOrderProduct, message } = action.payload;

      return produce(state, (draft) => {
        draft.items = purchaseOrderProduct;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default:
      return state;
  }
};

export default purchaseOrdersProductsReducer;
